import { createSlice } from '@reduxjs/toolkit';
import { 
  fetchProductById,
  updateCurProductSize,
  fetchProductDetails, 
  updateCurProductMaterial,
  fetchMaterialPriceAndImagesForCurProdct,
} from '../../services';
import { 
  ICurProductState,
} from '../../components/interfaces';

const initialState: ICurProductState = {
  productId: null,
  selectedMaterial: null,
  selectedSize: null,
  hasLocalSelectionChange: false,
  materialPrices: [],
  materialPriceAndImg: [],
  imgStatus: 'idle',
  productDetails: null,
  status: 'idle',
  error: null,
};

export const curProductSlice = createSlice({
  name: 'curProduct',
  initialState,
  reducers: {
    setCurProductSelectedMaterial: (state, action) => {
      state.selectedMaterial = action.payload;
      state.hasLocalSelectionChange = true;
    },
    setCurProductMaterialPreview: (state, action) => {
      state.selectedMaterial = action.payload.materialName;
      state.materialPriceAndImg = [action.payload];
      state.imgStatus = 'succeeded';
      state.hasLocalSelectionChange = true;
    },
    setCurProductSelectedSize: (state, action) => {
      state.selectedSize = action.payload;
      state.hasLocalSelectionChange = true;
    },
    clearMaterialPriceAndImages: (state) => {
      state.materialPriceAndImg = [];
      state.imgStatus = 'idle';
    },
    clearCurProductState: (state) => {
      state.productId = null;
      state.materialPrices = [];
      state.materialPriceAndImg = [];
      state.imgStatus = 'idle';
      state.productDetails = null;
      state.selectedMaterial = null;
      state.selectedSize = null;
      state.hasLocalSelectionChange = false;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductById.pending, (state) => {
        state.status = 'loading';
        state.error = null;
        state.hasLocalSelectionChange = false;
      })
      .addCase(fetchProductById.fulfilled, (state, action) => {
        state.status = 'succeeded';
      
        state.productId = action.payload.product;
        if (!state.hasLocalSelectionChange) {
          state.selectedMaterial = action.payload.selectedMaterial;
          state.selectedSize = action.payload.selectedSize;
        }
      })
      .addCase(fetchProductById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.toString() ?? 'Unknown error';
      })
      .addCase(fetchMaterialPriceAndImagesForCurProdct.pending, (state: ICurProductState) => {
        state.imgStatus = 'loading';
        state.error = null;
    })
    .addCase(fetchMaterialPriceAndImagesForCurProdct.fulfilled, (state: ICurProductState, action: { payload: any }) => {
        state.imgStatus = 'succeeded';
        state.materialPriceAndImg = action.payload;
    })
    .addCase(fetchMaterialPriceAndImagesForCurProdct.rejected, (state: ICurProductState, action: { payload: string | undefined }) => {
        state.imgStatus = 'failed';
        state.error = action.payload ? action.payload.toString() : 'Unknown error';
    })
      .addCase(fetchProductDetails.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchProductDetails.fulfilled, (state, action) => {
        state.productDetails = action.payload;
      })
      .addCase(fetchProductDetails.rejected, (state, action) => {
        state.error = action.payload?.toString() ?? 'Unknown error';
      })
      .addCase(updateCurProductSize.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.selectedSize = action.payload.selectedSize;
      })
      .addCase(updateCurProductSize.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.toString() ?? 'Unknown error';
      })
      .addCase(updateCurProductMaterial.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.selectedMaterial = action.payload.updateProduct.selectedMaterial;
      })
      .addCase(updateCurProductMaterial.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.toString() ?? 'Unknown error';
      });
  },
});

export const {
  clearMaterialPriceAndImages,
  clearCurProductState,
  setCurProductMaterialPreview,
  setCurProductSelectedMaterial,
  setCurProductSelectedSize,
} = curProductSlice.actions;

export default curProductSlice.reducer;
